import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-enrollment-errors',
  templateUrl: './enrollment-errors.component.html',
  styleUrls: ['./enrollment-errors.component.scss']
})
export class EnrollmentErrorsComponent implements OnInit {

  @Input() modalId: string;
  @Input() modalOpenButtonId: string;
  @Input() modalCloseButtonId: string;
  @Input() modalHeader: string = "Failed Vehicle(s)";
  @Input() enrollmentErrors = [];

  constructor() { }

  ngOnInit(): void {
  }

  onCancel() { }

}
